import { Injectable ,Output, EventEmitter} from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { DecimalPipe, DatePipe } from '@angular/common';
import { Observable } from 'rxjs';

import { map, catchError } from 'rxjs/operators';

import { SecurityService } from './../../Core/Security/security.service';
import { ConfigService } from './../../Core/Abstract/config.service';
import { LogService } from './../../Core/Abstract/log.service';

import { EventsEmitterService } from './../../Core/Abstract/emitter.service';
import { Router } from '@angular/router';
import * as moment from 'moment/moment';
import { GridService } from 'app/Core/Abstract/grid.service';

@Injectable()

export class UserListService extends SecurityService{
    @Output() change: EventEmitter<boolean> = new EventEmitter();
    constructor(http:HttpClient,configService:ConfigService,eventsEmitterService: EventsEmitterService, router:Router, logger:LogService, private datePipe:DatePipe) {
        super(http,configService,eventsEmitterService, router ,logger);
       
    }

    getUserList() {
        const serviceUrl = this.baseUrl + 'OnBoardService/getUserList';
        return this.http.get<any>(serviceUrl).pipe(map(response => {return response;}));
    }

    getIsBankUser() {
        const serviceUrl = this.baseUrl + 'UtilService/getIsBankUser';
        return this.http.get<any>(serviceUrl).pipe(map(response => {return response;}));
    }

    submitMultipleInvitationToken(token) {
        const serviceUrl = this.baseUrl + 'OnBoardService/cloneOnboardedUser?token=' + token;
        return this.http.get<any>(serviceUrl).pipe(map(res => res));
    }
}
